/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import n from "../core/Error.js";
import { i as e, a as t, l as o, P as r, b as i, c as a, d as s, e as c, f as l } from "../chunks/pe.js";
import _ from "./Point.js";
import u from "./SpatialReference.js";

function d() {
  return e();
}

function f() {
  return t();
}

function S() {
  return o();
}

function g(n, e) {
  var t = [];
  n = (n = (n = n.replace(/[\u00B0\u00BA]/g, "^")).replace(/\u2032/g, "'")).replace(/\u2033/g, '"');
  var o = M(e);
  return r.dms_to_geog(o, 1, [n], t) ? new _(t[0][0], t[0][1], e || u.WGS84) : null;
}

function w(n, e, t) {
  var o = [],
      r = v(t);
  if (-1 === r) return console.warn("invalid conversionMode: ".concat(t)), null;
  var a = M(e);
  return i.mgrs_to_geog_extended(a, 1, [n], r, o) ? new _(o[0][0], o[0][1], e || u.WGS84) : null;
}

function E(n, e) {
  var t = [];
  !e && /\(.+27/.test(n) && (e = u.GCS_NAD_1927);
  var o = M(e);
  return a.usng_to_geog(o, 1, [n], t) ? new _(t[0][0], t[0][1], e || u.WGS84) : null;
}

function m(n, e, t) {
  var o = [],
      r = R(t);
  if (-1 === r) return console.warn("invalid conversionMode: ".concat(t)), null;
  var i = M(e);
  return s.utm_to_geog(i, 1, [n], r, o) ? new _(o[0][0], o[0][1], e || u.WGS84) : null;
}

function P(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var o = [[n.x, n.y]],
      i = [],
      a = M(n.spatialReference);
  var s = 0;

  switch (e) {
    case "dd":
      s = r.geog_to_dd(a, 1, o, t, i);
      break;

    case "ddm":
      s = r.geog_to_ddm(a, 1, o, t, i);
      break;

    case "dms":
      s = r.geog_to_dms(a, 1, o, t, i);
      break;

    default:
      return console.warn("invalid format: ".concat(e)), null;
  }

  return s ? i[0] : null;
}

function k(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  var r = [[n.x, n.y]],
      a = [],
      s = M(n.spatialReference);
  var c = v(e);
  if (-1 === c) return console.warn("invalid conversionMode: ".concat(e)), null;
  o && (c |= i.PE_MGRS_ADD_SPACES);
  return i.geog_to_mgrs_extended(s, 1, r, t, !1, c, a) ? a[0] : null;
}

function p(n) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var o = [[n.x, n.y]],
      r = [],
      i = M(n.spatialReference);
  return a.geog_to_usng(i, 1, o, e, !1, t, r) ? r[0] : null;
}

function G(n, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var o = [[n.x, n.y]],
      r = [],
      i = M(n.spatialReference);
  var a = R(e);
  if (-1 === a) return console.warn("invalid conversionMode: ".concat(e)), null;
  t && (a |= s.PE_UTM_OPTS_ADD_SPACES);
  return s.geog_to_utm(i, 1, o, a, r) ? r[0] : null;
}

function M(e) {
  var t = null;

  if (e || (e = u.WGS84), e.wkid) {
    if (t = c.geogcs(e.wkid), !t) throw new n("coordinate-formatter:invalid-spatial-reference", "wkid is not valid");
  } else {
    if (!e.wkt) throw new n("coordinate-formatter:invalid-spatial-reference", "wkid and wkt are missing");
    if (t = c.fromString(l.PE_TYPE_GEOGCS, e.wkt), !t) throw new n("coordinate-formatter:invalid-spatial-reference", "wkt is not valid");
  }

  return t;
}

function v(n) {
  var e = -1;

  switch (n) {
    case "automatic":
      e = i.PE_MGRS_STYLE_AUTO;
      break;

    case "new-180-in-zone-01":
      e = i.PE_MGRS_STYLE_NEW | i.PE_MGRS_180_ZONE_1_PLUS;
      break;

    case "new-180-in-zone-60":
      e = i.PE_MGRS_STYLE_NEW;
      break;

    case "old-180-in-zone-01":
      e = i.PE_MGRS_STYLE_OLD | i.PE_MGRS_180_ZONE_1_PLUS;
      break;

    case "old-180-in-zone-60":
      e = i.PE_MGRS_STYLE_OLD;
  }

  return e;
}

function R(n) {
  var e = -1;

  switch (n) {
    case "latitude-band-indicators":
      e = s.PE_UTM_OPTS_NONE;
      break;

    case "north-south-indicators":
      e = s.PE_UTM_OPTS_NS;
  }

  return e;
}

export { g as fromLatitudeLongitude, w as fromMgrs, E as fromUsng, m as fromUtm, d as isLoaded, f as isSupported, S as load, P as toLatitudeLongitude, k as toMgrs, p as toUsng, G as toUtm };